import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator.ts'
import { PaginationRequestSchema } from '@/core/infrastructure/schemas/pagination/PaginationSchema.ts'

/**
 * Implémentation du type PaginationRequestEntity
 */
export default class PaginationRequest {
  readonly limit: number | null
  readonly page: number | null
  readonly offset: number | null
  readonly sortBy: string[] | null

  constructor(request: PaginationRequest) {
    this.limit = request.limit ?? null
    this.page = request.page ?? null
    this.offset = request.offset ?? null
    this.sortBy = request.sortBy ?? null
  }

  /**
   * Transforme en query params utilisables par Axios
   */
  toQueryParams(): Record<string, any> {
    return Object.fromEntries(
      Object.entries(this).filter(([_, v]) => v !== null && v !== undefined)
    )
  }

  public static create(data: unknown): PaginationRequest {
    return EntityValidator.validateAndCreate(
      PaginationRequestSchema,
      data,
      PaginationRequest,
      'PaginationRequest'
    )
  }
}